import { render, staticRenderFns } from "./TriviaPodium.vue?vue&type=template&id=57b6f840&scoped=true&"
import script from "./TriviaPodium.vue?vue&type=script&lang=js&"
export * from "./TriviaPodium.vue?vue&type=script&lang=js&"
import style0 from "./TriviaPodium.vue?vue&type=style&index=0&id=57b6f840&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b6f840",
  null
  
)

export default component.exports